var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_30",
    "data-name": "Componente 30",
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 30,
    viewBox: "0 0 6 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2154",
    "data-name": "Ret\\xE2ngulo 2154",
    width: 2,
    height: 2,
    fill: "#b9b9b9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2168",
    "data-name": "Ret\\xE2ngulo 2168",
    width: 2,
    height: 2,
    transform: "translate(0 16)",
    fill: "#b9b9b9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2157",
    "data-name": "Ret\\xE2ngulo 2157",
    width: 2,
    height: 2,
    transform: "translate(0 4)",
    fill: "#b9b9b9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2167",
    "data-name": "Ret\\xE2ngulo 2167",
    width: 2,
    height: 2,
    transform: "translate(0 20)",
    fill: "#b9b9b9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2159",
    "data-name": "Ret\\xE2ngulo 2159",
    width: 2,
    height: 2,
    transform: "translate(0 8)",
    fill: "#b9b9b9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2164",
    "data-name": "Ret\\xE2ngulo 2164",
    width: 2,
    height: 2,
    transform: "translate(0 24)",
    fill: "#b9b9b9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2161",
    "data-name": "Ret\\xE2ngulo 2161",
    width: 2,
    height: 2,
    transform: "translate(0 12)",
    fill: "#b9b9b9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2163",
    "data-name": "Ret\\xE2ngulo 2163",
    width: 2,
    height: 2,
    transform: "translate(0 28)",
    fill: "#b9b9b9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2155",
    "data-name": "Ret\\xE2ngulo 2155",
    width: 2,
    height: 2,
    transform: "translate(4)",
    fill: "#b9b9b9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2169",
    "data-name": "Ret\\xE2ngulo 2169",
    width: 2,
    height: 2,
    transform: "translate(4 16)",
    fill: "#b9b9b9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2156",
    "data-name": "Ret\\xE2ngulo 2156",
    width: 2,
    height: 2,
    transform: "translate(4 4)",
    fill: "#b9b9b9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2166",
    "data-name": "Ret\\xE2ngulo 2166",
    width: 2,
    height: 2,
    transform: "translate(4 20)",
    fill: "#b9b9b9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2158",
    "data-name": "Ret\\xE2ngulo 2158",
    width: 2,
    height: 2,
    transform: "translate(4 8)",
    fill: "#b9b9b9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2165",
    "data-name": "Ret\\xE2ngulo 2165",
    width: 2,
    height: 2,
    transform: "translate(4 24)",
    fill: "#b9b9b9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2160",
    "data-name": "Ret\\xE2ngulo 2160",
    width: 2,
    height: 2,
    transform: "translate(4 12)",
    fill: "#b9b9b9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2162",
    "data-name": "Ret\\xE2ngulo 2162",
    width: 2,
    height: 2,
    transform: "translate(4 28)",
    fill: "#b9b9b9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/dragIcon.8ef3ec9c.svg";
export { ForwardRef as ReactComponent };